export default __webpack_public_path__ + "static/media/security.862130bb.webp";